module.exports = __webpack_public_path__ + "images/signLoading.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/reusableComponents/DetailsPageWrapper/signLoading.gif
// module id = 2507
// module chunks = 0